export default __webpack_public_path__ + "static/media/logo-general-de-salud.02a38beb.svg";